import PropTypes from 'prop-types';
import React, { Component } from 'react';

export default class LeftLinks extends Component {
  render() {
    const {
      theme,
      s,
      data = [],
      changeBatch,
      handleClickQuestion,
    } = this.props;
    return (
      <div className={s.leftRecommand}>
        <div className={s.leftListTitle}>
          <div className={s.tit}>
            {theme === 'customized3' ? '大家都在问' : '猜你喜欢'}
          </div>
          {theme !== 'customized3' && (
            <div className={s.change} onClick={changeBatch}>
              换一批
            </div>
          )}
        </div>
        <ol className={s.leftList}>
          {data.map(({ title }) => (
            <li key={title} onClick={() => handleClickQuestion(title)}>
              {title}
            </li>
          ))}
        </ol>
      </div>
    );
  }
}

LeftLinks.propTypes = {
  s: PropTypes.shape().isRequired,
  changeBatch: PropTypes.func.isRequired,
  handleClickQuestion: PropTypes.func.isRequired,
  data: PropTypes.array.isRequired,
};
